// extracted by mini-css-extract-plugin
export default {"eventHistoryHeaderContainer":"eventHistoryHeader_eventHistoryHeaderContainer__9tgai","divider":"eventHistoryHeader_divider__tOoMb"};